"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Audiences",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Customers",
    transform: "translate(-20.000000, -14.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "navigation-bar"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "proximity-logo",
    transform: "translate(20.000000, 14.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "customers"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Mask",
    fill: "#9466EC",
    x: "0",
    y: "0",
    width: "32",
    height: "32",
    rx: "5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.3753158,19.1718598 C15.1134389,18.8367187 14.7583014,18.6036084 14.3922376,18.3905613 C13.7761748,18.0320303 13.1513358,17.6891726 12.4739451,17.4475568 C12.381037,17.4144268 12.2910542,17.3699791 12.2057239,17.3208329 C11.8623233,17.1230475 11.7540832,16.7643793 11.9446929,16.4213502 C12.0221281,16.2819367 12.126174,16.1555214 12.2259198,16.0290375 C12.7069557,15.4190478 13.0684022,14.7525039 13.215589,13.9916802 C13.368098,13.2034881 13.3638332,12.4220867 12.9988973,11.6805031 C12.6122147,10.8947461 11.9606241,10.4419009 11.0833187,10.2934676 C10.8890082,10.2606119 10.6956493,10.2427437 10.5036297,10.2405487 L10.5036297,10.24 C10.5002108,10.2400343 10.4967567,10.2402401 10.4933379,10.2402744 C10.489919,10.2402401 10.4864649,10.2400343 10.4830461,10.24 L10.4830461,10.2405487 C10.2910265,10.2427437 10.0976323,10.2606119 9.90332177,10.2934676 C9.0260517,10.4419009 8.37446104,10.8947461 7.98777844,11.6805031 C7.62284255,12.4220867 7.6185778,13.2034881 7.77108674,13.9916802 C7.91827355,14.7525039 8.2797201,15.4190478 8.76072068,16.0290375 C8.86050178,16.1555214 8.96454763,16.2819367 9.04198284,16.4213502 C9.23259259,16.7643793 9.12435248,17.1230475 8.78095182,17.3208329 C8.69562154,17.3699791 8.60563879,17.4144268 8.51273064,17.4475568 C7.83533999,17.6891726 7.21050094,18.0320303 6.59443813,18.3905613 C6.22837437,18.6036084 5.87323684,18.8367187 5.61135992,19.1718598 C5.25505927,19.6278602 5.16750849,20.1347902 5.38370675,20.6715578 C5.51513865,20.9977819 5.78928114,21.2043814 6.09884575,21.3640981 C6.62443238,21.6352771 7.19915177,21.745779 7.77908755,21.831965 C8.42680117,21.9282683 9.08064758,21.9583117 9.73463497,21.9676059 C9.98410534,21.9711727 10.2335757,21.9731961 10.4830461,21.9732647 L10.4830461,21.9733333 C10.4864649,21.9733333 10.489919,21.973299 10.4933379,21.973299 C10.4967567,21.973299 10.5001756,21.9733333 10.5036297,21.9733333 L10.5036297,21.9732647 C10.7530648,21.9731961 11.0025704,21.9711727 11.2520408,21.9676059 C11.9060282,21.9583117 12.5598746,21.9282683 13.2075882,21.831965 C13.787524,21.745779 14.3622434,21.6352771 14.88783,21.3640981 C15.1973946,21.2043814 15.4715371,20.9977819 15.6029338,20.6715578 C15.8191673,20.1347902 15.7316165,19.6278602 15.3753158,19.1718598",
    id: "Fill-1-Copy-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-290",
    fill: "#FFAEFF",
    x: "18",
    y: "12",
    width: "8",
    height: "2",
    rx: "1"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-290-Copy",
    fill: "#DA94F2",
    x: "18",
    y: "15",
    width: "8",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-290-Copy-2",
    fill: "#DA94F2",
    x: "18",
    y: "17",
    width: "8",
    height: "1",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "Rectangle-290-Copy-3",
    fill: "#DA94F2",
    x: "18",
    y: "19",
    width: "8",
    height: "1",
    rx: "0.5"
  })))))));
};

exports["default"] = _default;